import { render, staticRenderFns } from "./EditorText.vue?vue&type=template&id=5e6ba7ea&"
import script from "./EditorText.vue?vue&type=script&lang=js&"
export * from "./EditorText.vue?vue&type=script&lang=js&"
import style0 from "./EditorText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e6ba7ea')) {
      api.createRecord('5e6ba7ea', component.options)
    } else {
      api.reload('5e6ba7ea', component.options)
    }
    module.hot.accept("./EditorText.vue?vue&type=template&id=5e6ba7ea&", function () {
      api.rerender('5e6ba7ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/61980520-8/components/EditorText.vue"
export default component.exports